/**
 * 拦截所有请求
 */
let installed = false;

function install(Vue: any, options: any) {
    if (installed) {
        return;
    }

    installed = true;

    const send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body?: Document | BodyInit | null) {
        if (typeof options.afterResponse == 'function') {
            options.beforeRequest(this);
        }

        if (this.onreadystatechange) {
            (this as any).__onreadystatechange = this.onreadystatechange;
        }

        this.onreadystatechange = onreadystatechange;

        send.apply(this, [body]);
    };

    function onreadystatechange(this: XMLHttpRequest, ...args: any[]) {
        if (this.readyState == 4) {
            if (typeof options.afterResponse == 'function') {
                options.afterResponse(this);
            }
        }

        if ((this as any).__onreadystatechange) {
            return (this as any).__onreadystatechange.apply(this, args);
        }
    }
}

export { install };
